import { MouthDescriptor } from "../commons/model/Scan";

export default class SmileSimulationTreatmentSettings {
  alignersEnabled: boolean;
  metallicBracesEnabled: boolean;
  selfLigatingBracesEnabled: boolean;
  ceramicBracesEnabled: boolean;
}

export function isScanEnabled(
  descriptor: MouthDescriptor,
  settings: SmileSimulationTreatmentSettings
): boolean {
  switch (descriptor) {
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_ALIGNERS:
      return settings.alignersEnabled;
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_CERAMIC_BRACES:
      return settings.ceramicBracesEnabled;
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_METALLIC_BRACES:
      return settings.metallicBracesEnabled;
    case MouthDescriptor.FACE_MOUTH_SLIGHTLY_OPENED_SELF_LIGATING_BRACES:
      return settings.selfLigatingBracesEnabled;
    default:
      return true;
  }
}
